import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React from 'react';
import PropTypes from 'prop-types';
import { modalTypes } from './constants.js';
import { D as DSModal$2, i as iconSizes, s as sizes } from './DSModal-301a5489.js';
import DSModal$1 from './v2/DSModal.js';
export { DSModalContent } from './v2/components/ModalContent.js';
import '@babel/runtime/helpers/esm/extends';
import '@babel/runtime/helpers/esm/defineProperty';
import 'react-modal';
import '@elliemae/ds-classnames';
import '@elliemae/ds-icons/Close';
import '@elliemae/ds-basic/Icon';
import '@elliemae/ds-basic/Button';
import './v1/ModalFeedBack/ModalFeedBack.js';
import '@elliemae/ds-icons/WarningCircle';
import '@elliemae/ds-icons/CheckmarkCircle';
import '@elliemae/ds-icons/HelpCircle';
import '@elliemae/ds-icons/InfoCircle';
import 'react-desc';
import './v2/components/SelectionHeader.js';
import '@elliemae/ds-basic/form/SearchBox';
import './v2/blocks.js';
import './v2/components/Title.js';
import './v2/components/DecisionHeader.js';
import './v2/components/FormHeader.js';
import './v2/components/FeedbackIcon.js';
import '@elliemae/ds-icons/ErrorHexegon';
import '@elliemae/ds-icons/WarningTriangle';
import './v2/components/Footer.js';
import './v2/helpers.js';

var DSModal = function DSModal(_ref) {
  var _ref$version = _ref.version,
      version = _ref$version === void 0 ? 1 : _ref$version,
      rest = _objectWithoutProperties(_ref, ["version"]);

  if (version === 2) return /*#__PURE__*/React.createElement(DSModal$1, rest);
  return /*#__PURE__*/React.createElement(DSModal$2, rest);
};

DSModal.propTypes = {
  version: PropTypes.oneOf([1, 2])
};
DSModal$2.propTypes = {
  version: PropTypes.oneOf([1, 2]),
  className: PropTypes.string,

  /**
   * Add an additional css class to the footer
   */
  additionalFooterCssClass: PropTypes.string,

  /**
   * Set style for the modal
   */
  style: PropTypes.objectOf(PropTypes.string),

  /**
   * Select size for the close icon
   */
  iconCloseSize: PropTypes.oneOf(iconSizes),

  /**
   * ['default', 'alert', 'confirm', 'notification', 'warning', 'error', 'success', 'help', 'info']
   */
  modalType: PropTypes.oneOf(modalTypes),

  /**
   * Show the header or not
   */
  showHeader: PropTypes.bool,

  /**
   * Show the footer or not
   */
  showFooter: PropTypes.bool,

  /**
   * Main content of the modal
   */
  children: PropTypes.element.isRequired,

  /**
   * Content is centered or not
   */
  centered: PropTypes.bool,

  /**
   * Text to be added in the confirm button
   */
  confirmLabel: PropTypes.string,

  /**
   * Text to be added in the modal title
   */
  modalTitle: PropTypes.string,

  /**
   * Text to be added in the modal title
   */
  size: PropTypes.oneOf(sizes),

  /**
   * Modal is open or not
   */
  isOpen: PropTypes.bool,

  /**
   * Allows a function to be triggered once the modal is closed
   */
  onClose: PropTypes.func,

  /**
   * Allows a function to be triggered once the modal is opened
   */
  onAfterOpen: PropTypes.func,

  /**
   * Allows a function to be triggered once the modal open is confirmed
   */
  onConfirm: PropTypes.func,

  /**
   * Allows a function to be triggered once the modal open is rejected
   */
  onReject: PropTypes.func,

  /**
   * Text to be added in the reject button
   */
  rejectLabel: PropTypes.string,

  /**
   * If modal should close on overlay click
   */
  shouldCloseOnOverlayClick: PropTypes.bool,

  /**
   * Modal has error or not
   */
  hasError: PropTypes.bool,

  /**
   * Modal has warning or not
   */
  hasWarning: PropTypes.bool,

  /**
   * Modal has success or not
   */
  hasSuccess: PropTypes.bool,

  /**
   * Modal has info or not
   */
  hasInfo: PropTypes.bool,

  /**
   * Modal has help or not
   */
  hasHelp: PropTypes.bool,
  actionsRef: PropTypes.func,
  appElement: PropTypes.string,

  /**
   * Customized props for the confirm button
   */
  overridePropsConfirmButton: PropTypes.objectOf(PropTypes.shape({})),

  /**
   * Customized props for the reject button
   */
  overridePropsRejectButton: PropTypes.objectOf(PropTypes.string),

  /**
   * Show confirm button
   */
  showConfirmButton: PropTypes.bool,

  /**
   * Show confirm button
   */
  customCloseComponent: PropTypes.element
};

export default DSModal;
//# sourceMappingURL=DSModal.js.map
